<template>
  <div class="align-middle">
    <p class="q-mb-none text-no-wrap">
      <PEditable
        :model-value="col.value || tableProps.value || 0"
        :type="col.type"
        disable
      />
      / {{ useChangeCase(tableProps.row.unit ?? "", "capitalCase").value }}
    </p>
    <p class="q-mb-xs text-xxs text-neutral-70 text-italic text-nowrap">
      (exc. tax)
    </p>
    <p class="q-mb-none text-no-wrap">
      <PEditable
        :model-value="tableProps.row.rate_wt || 0"
        :type="col.type"
        disable
      />
      / {{ useChangeCase(tableProps.row.unit ?? "", "capitalCase").value }}
    </p>
    <p class="q-mb-none text-xxs text-neutral-70 text-italic text-nowrap">
      (inc. tax)
    </p>
  </div>
</template>

<script setup>
import { useChangeCase } from "@vueuse/integrations/useChangeCase";

defineProps({
  col: {
    type: Object,
    default: () => {
      return {};
    },
  },
  tableProps: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>
